export default __webpack_public_path__ + "static/media/IPRequest.70990f0c.svg";